import { fNumber } from '../../../utils/formatNumber';

export function getAccountStateColor(status) {
  switch (status) {
    case 'active':
      return 'success';
    case 'suspended':
    case 'blocked':
      return 'error';
    case 'pending':
      return 'warning';
    default:
      return 'default';
  }
}

export function getDecisionStatus(row) {
  if (row?.requires_review) {
    return 'awaiting review';
  }

  if (row?.allowed) {
    return 'resolved';
  }

  return 'failed';
}

export function formatWalletAmount(value, currency = '') {
  const raw = Number(value || 0);
  const formatted = fNumber(Number.isFinite(raw) ? raw : 0);
  return currency ? `${currency} ${formatted}` : formatted;
}

export function buildUserPatch(payload = {}) {
  const keys = [
    'user_id',
    'first_name',
    'last_name',
    'display_name',
    'email',
    'phone',
    'gender',
    'dob',
    'account_verification_status',
    'created_at',
    'last_seen_at',
    'image_url',
    'referral_id',
  ];

  return keys.reduce((acc, key) => {
    if (payload[key] !== undefined) {
      acc[key] = payload[key];
    }

    return acc;
  }, {});
}
